import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'temporal-polyfill';
import App from '@/App.tsx';
import '@/styles/index.css';
import { MsalProvider } from '@azure/msal-react';
import { initializeMsal, msalInstance } from '@/authSetup';
import { createAuthenticatedAxios } from '@/lib/createAuthenticatedAxios';
import { enableMocking } from '@/mocks/browser.ts';
import { clock } from '@/models/common/clock';
import { createRouter } from '@/routes/routes.tsx';
import { runtimeConfig } from '@/runtimeConfig';
import { InitDealerService } from '@/services/dealerService.ts';
import { InitLeadService } from '@/services/leadService.ts';
import { InitUserService, userService } from '@/services/userService.ts';

if (import.meta.env.DEV) {
  await enableMocking();
  console.log(`Using clock with now:${clock.getInstant().toString()}`);
}

await initializeMsal();

const axiosInstance = createAuthenticatedAxios(
  msalInstance,
  runtimeConfig.ApiBaseUrl.Or('/api/V1'),
);

InitLeadService(axiosInstance);
InitUserService(axiosInstance);
InitDealerService((await userService.getCurrentUser()).domain);

const url = new URL(globalThis.location.href);

if (url.pathname === '/') {
  url.pathname = '/leads';
  globalThis.history.pushState(null, 'rewrite', url);
}

const rootElement = document.getElementById('root');
if (rootElement) {
  const router = createRouter();
  createRoot(rootElement).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App clock={clock} router={router} />
      </MsalProvider>
    </StrictMode>,
  );
}
